import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from '@app/app-routing.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BotaoAcaoConcursoComponent } from '@app/shared/botao-acao-concurso/botao-acao-concurso.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CoreModule } from '@app/core/core.module';
import { DataItensResultadoQuestionarioPipe } from '@app/core/pipes/dataItensResultadoQuestionario';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DsGovDirectivesModule } from '@sigepe/dsgov-theme';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ManterConcursoComponent } from './tabela-concurso/manter-concurso.component';
import { ManterQuestionarioCargoComponent } from '@tabelasAdministrativas/tabela-questionario-cargo/manter-questionario-cargo/manter-questionario-cargo.component';
import { ManterTabelaAdministrativaComponent } from '@tabelasAdministrativas/manter-tabela-administrativa/manter-tabela-administrativa.component';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { PesquisarConcursoComponent } from './tabela-concurso/pesquisar-concurso.component';
import { PesquisarQuestionarioCargoComponent } from '@tabelasAdministrativas/tabela-questionario-cargo/pesquisar-questionario-cargo/pesquisar-questionario-cargo.component';
import { PesquisarTabelaAdministrativaComponent } from '@tabelasAdministrativas/pesquisar-tabela-administrativa/pesquisar-tabela-administrativa.component';
import { SharedModule } from '@app/shared/shared.module';
import { TabelaAreaAtuacaoComponent } from './tabela-area-atuacao/tabela-area-atuacao.component';
import { TabelaAreaConhecimentoComponent } from './tabela-area-conhecimento/tabela-area-conhecimento.component';
import { TabelaConcursoComponent } from './tabela-concurso/tabela-concurso.component';
import { TabelaIdiomaComponent } from '@tabelasAdministrativas/tabela-idioma/tabela-idioma.component';
import { TabelaIncentivoComponent } from './tabela-incentivo/tabela-incentivo.component';
import { TabelaInstituicaoComponent } from '@tabelasAdministrativas/tabela-instituicao/tabela-instituicao.component';
import { TabelaQuestionarioCargoComponent } from '@tabelasAdministrativas/tabela-questionario-cargo/tabela-questionario-cargo/tabela-questionario-cargo.component';
import { TabelaSoftskillComponent } from '@tabelasAdministrativas/tabela-softskill/tabela-softskill.component';
import { TabelaTipoDocumentoComponent } from './tabela-tipo-documento/tabela-tipo-documento.component';
import { TabelaTipoMovimentacaoComponent } from './tabela-tipo-movimentacao/tabela-tipo-movimentacao.component';
import { TabelaVinculoComponent } from '@tabelasAdministrativas/tabela-vinculo/tabela-vinculo.component';
import { TableModule } from 'primeng/table';
import { TextoAjudaComponent } from '@app/shared/texto-ajuda/texto-ajuda.component';
import { ToastModule } from 'primeng/toast';

@NgModule({
	declarations: [
		ManterTabelaAdministrativaComponent,
		PesquisarTabelaAdministrativaComponent,
		PesquisarConcursoComponent,
		PesquisarQuestionarioCargoComponent,
		ManterConcursoComponent,
		ManterQuestionarioCargoComponent,
		TabelaIdiomaComponent,
		TabelaSoftskillComponent,
		TabelaInstituicaoComponent,
		TabelaVinculoComponent,
		TabelaAreaConhecimentoComponent,
		TabelaAreaAtuacaoComponent,
		TabelaTipoDocumentoComponent,
		TabelaIncentivoComponent,
		TabelaTipoMovimentacaoComponent,
		TabelaConcursoComponent,
		TabelaQuestionarioCargoComponent
	],
	imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    SharedModule,
    AppRoutingModule,
    BotaoAcaoConcursoComponent,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ButtonModule,
    ConfirmDialogModule,
    DialogModule,
    InputMaskModule,
    InputTextModule,
    InputNumberModule,
    MessagesModule,
    MessageModule,
    TableModule,
    CalendarModule,
    TextoAjudaComponent,
    ToastModule,
    DsGovDirectivesModule,
    AutoCompleteModule,
    CoreModule
],
	providers: [MessageService, ConfirmationService, DataItensResultadoQuestionarioPipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class TabelasAdministrativasModule {}
